import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';

const sliders = document.querySelectorAll('.block-media-slider-grid .swiper');

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const slides = slider.querySelectorAll('.swiper-slide');

		const settings = {
			loop: slides.length > 1, // Enable loop only if more than 1 slide
			grabCursor: true,
			spaceBetween: 10,
			slidesPerView: 1,
			modules: [A11y, Navigation],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
				slideLabelMessage: '',
			},
			navigation: {
				prevEl: slider.parentElement.querySelector(
					'.swiper-button-prev'
				),
				nextEl: slider.parentElement.querySelector(
					'.swiper-button-next'
				),
			},
		};

		// Initialize Swiper instance
		const swiperInstance = new Swiper(slider, settings);

		// Check for the .block-hero-post-product-info parent and thumbnails
		const parentBlock = slider.closest('.block-hero-post-product-info');
		if (parentBlock) {
			const thumbnails = parentBlock.querySelectorAll(
				'.block-hero-post-product-info__thumbnails .wp-block-image'
			);

			// Add click event listeners to each thumbnail
			thumbnails.forEach((thumbnail, index) => {
				const realIndex = index;
				thumbnail.addEventListener('click', () => {
					// Slide to the clicked thumbnail's corresponding index
					swiperInstance.slideToLoop(realIndex, 500); // 500ms transition

					// Optional: Highlight the active thumbnail
					thumbnails.forEach((thumb) =>
						thumb.classList.remove('is-active')
					);
					thumbnail.classList.add('is-active');
				});
			});
		}
	});
}
